/**
 * 页面权限 Key 值，亦是 router name 和 menu key
 */
export enum PermissionPageKey {
  System = 'system', // 系统管理
  SystemDataMonitoring = 'system-data-monitoring', // 系统管理：数据监控
  SystemDataMonitoringDemandAi = 'system-data-monitoring-demand-ai', // 系统管理：数据监控 - 需求文档 AI
  SystemUserManagement = 'system-user', // 系统管理：用户管理
  SystemUserManagementUser = 'system-user-management', // 系统管理：用户管理 - 系统用户管理
  SystemUserManagementRole = 'system-role-management', // 系统管理：用户管理 - 系统角色管理
  SystemUserManagementCollection = 'system-collection-management', // 系统管理：用户管理 - 用户集管理
  SystemUserManagementOrganization = 'system-organization-management', // 系统管理：用户管理 - 组织管理
  SystemProjectManagement = 'system-project-management', // 系统管理：项目管理
  SystemProjectManagementProductLine = 'system-project-management-product-line', // 系统管理：项目管理 - 产品线
  SystemProjectManagementSeries = 'system-project-management-series', // 系统管理：项目管理 - 产品系列
  SystemProjectManagementProject = 'system-project-management-project', // 系统管理：项目管理 - 系统项目
  SystemProjectManagementProjectSort = 'system-project-management-project-sort', // 系统管理：项目管理 - 系统项目排序
  SystemPermissionManagement = 'system-permission-management', // 系统管理：权限管理
  SystemPermissionManagementMenu = 'system-permission-management-menu', // 系统管理：菜单权限
  SystemPermissionManagementFunction = 'system-permission-management-function', // 系统管理：权限管理 - 功能权限
  SystemNotificationManagement = 'system-notification-management', // 系统管理：通知管理
  SystemAiAffairs = 'system-ai-affairs', // 系统管理：AI 事项（分组）
  SystemAiWorkItem = 'system-ai-work-item', // 系统管理：AI 事项 - 工单审核
  SystemRobotChatAudit = 'system-robot-chat-audit', // 系统管理：AI 事项 - 机器人对话记录
  SystemTools = 'system-tools', // 系统工具
  SystemToolModelManagement = 'system-tools-model-management', // 系统管理：模型管理
  SystemToolClientManagement = 'system-tools-client-management', // 系统管理：客户端管理

  Precision = 'precision', // 精准测试预研
  PrecisionNew = 'precision-new', // 精准测试（新）
  PrecisionNewSelector = 'precision-new-selector', // 精准测试（新）：需求用例页面待定
  PrecisionCoverTask = 'precision-cover-task', // 精准测试：覆盖率任务
  PrecisionCoverTaskList = 'precision-cover-task-list', // 精准测试：覆盖率任务 - 覆盖率任务列表
  PrecisionCoverTaskApiReport = 'precision-cover-task-api-report', // 精准测试：覆盖率任务 - 接口覆盖率列表
  PrecisionCoverTaskFull = 'precision-cover-task-full', // 精准测试：覆盖率任务 - 全量覆盖率
  PrecisionCoverTaskIncrement = 'precision-cover-task-increment', // 精准测试：覆盖率任务 - 增量覆盖率
  PrecisionCaseRecommend = 'precision-test-case-recommend', // 精准测试：用例推荐
  PrecisionCoverServerList = 'precision-cover-server-list', // 精准测试：覆盖率任务 - 服务列表
  PrecisionNewCoverageReport = 'precision-new-coverage-report', // 精准测试（新）：覆盖率报告
  PrecisionNewCoverageReportDetail = 'precision-new-coverage-report-detail', // 精准测试（新）：覆盖率报告详情
  PrecisionNewAnalyzing = 'precision-new-analyzing', // 精准测试（新）：AI分析中
  PrecisionNewTestPlan = 'precision-new-test-plan', // 精准测试（新）：测试计划
  PrecisionNewCaseRecommend = 'precision-new-case-recommend', // 精准测试（新）：用例推荐（AI）
  PrecisionNewTestPlanDetail = 'precision-new-test-plan-detail', // 精准测试（新）：测试计划详情
  PrecisionNewTestCaseGeneration = 'precision-new-test-case-generation', // 精准测试（新）：测试用例
  PrecisionNewFeishuDocument = 'precision-new-feishu-document', // 精准测试（新）：飞书文档
  PrecisionNewDocumentAnalyze = 'precision-new-document-analyze', // 精准测试（新）：文档分析
  PrecisionNewKnowledgeGraph = 'precision-new-knowledge-graph', // 精准测试（新）：知识图谱
  PrecisionNewKnowledgeGraphForDocument = 'precision-new-knowledge-graph-for-document', // 精准测试（新）：知识图谱详情
  // PrecisionNewAIAnalysis = 'precision-new-ai-analysis', // 精准测试（新）：AI分析页面 [已废弃：现使用全局任务面板]
  PytestProjects = 'pytest-projects', // Pytest：项目列表
  PytestProjectDetail = 'pytest-project-detail', // Pytest：项目详情
  PytestProjectEditor = 'pytest-project-editor', // Pytest：YAML编辑器
  PytestProjectCases = 'pytest-project-cases', // Pytest：用例管理
  PytestProjectExecute = 'pytest-project-execute', // Pytest：测试执行
  PytestReports = 'pytest-reports', // Pytest：报告列表
  PytestReportDetail = 'pytest-report-detail', // Pytest：报告详情
  PytestReceivedArtifacts = 'pytest-received-artifacts', // Pytest：接收产物
  PytestAllReports = 'pytest-all-reports', // Pytest：全部报告（跨项目）
  PrecisionNewCodeBinding = 'precision-new-code-binding', // 精准测试（新）：代码绑定
  PrecisionNewImpactAnalysis = 'precision-new-impact-analysis', // 精准测试（新）：影响分析

  Issue = 'issue', // 问题管理
  IssueDashboard = 'issue-dashboard', // 问题管理：问题看板
  IssueList = 'issue-list', // 问题管理：问题列表
  IssueDetail = 'issue-detail', // 问题管理：问题详情
  IssueSetting = 'issue-setting', // 问题管理：问题设置
  IssueSettingFieldConfig = 'issue-setting-field-config', // 问题管理：设置 - 字段配置
  IssueSettingTemplateConfig = 'issue-setting-template-config', // 问题管理：设置 - 问题模板配置
  IssueSettingSchemeConfig = 'issue-setting-scheme-config', // 问题管理：设置 - 模板方案配置
  IssueSettingProjectConfig = 'issue-setting-project-config', // 问题管理：设置 - 项目配置
  IssueSettingDeptResponsibleMapping = 'issue-setting-dept-responsible-mapping', // 问题管理：设置 - 部门-责任方映射
  IssueSettingDeptRollupRule = 'issue-setting-dept-rollup-rule', // 问题管理：设置 - 部门归并规则
  IssueFeishuWorkItemSetting = 'issue-feishu-work-item-setting', // 问题管理：飞书工作项设置

  // Cloudtest = 'cloudtest', // 云测平台
  CloudtestDashboard = 'cloudtest-dashboard', // 云测平台：看板
  CloudtestQualitySummary = 'cloudtest-quality-summary', // 云测平台：质量概览
  CloudtestQualitySummaryDevelopQuality = 'cloudtest-develop-quality', // 云测平台：质量概览 - 研发质量
  CloudtestAccidentReview = 'cloudtest-accident-review', // 云测平台：事故复盘
  CloudtestAccidentReviewDetail = 'cloudtest-accident-review-detail', // 云测平台：事故复盘详情
  CloudtestProduceFixtureManage = 'cloudtest-produce-fixture-manage', // 云测平台：生产 - 治具管理
  CloudtestTestCase = 'cloudtest-test-case', // 云测平台：测试用例
  CloudtestTestCaseMind = 'cloudtest-test-case-mind', // 云测平台：测试用例思维导图
  Project = 'project', // 项目空间
  ProjectDashboard = 'project-dashboard', // 项目空间：项目质量看板
  ProjectTRReview = 'project-tr-review', // 项目空间：转阶段评审
  OldProjectTRReview = 'old-project-tr-review', // 项目空间：转阶段评审(旧)
  NewProjectTRReview = 'new-project-tr-review', // 项目空间：新转阶段评审(新)
  StandardsControlled = 'standards-controlled', // 项目空间：新转阶段评审(新)
  ProjectTrStandardsRepository = 'project-tr-standards-repository', // 项目空间：转阶段评审标准库
  ProjectTrModule = 'project-tr-module', // 项目空间：转阶段评审模块库
  ProjectTRReviewDetail = 'project-tr-review-detail', // 项目空间：转阶段评审详情
  ProjectPrototypeManagement = 'project-prototype-management', //  项目空间：样机管理
  ProjectPrototypeList = 'project-prototype-list', //  项目空间：样机管理 - 样机列表
  ProjectPrototypeTestReport = 'project-prototype-test-report', // 项目空间：样机管理 - 样机试装报告
  ProjectPrototypeTestReportDetail = 'project-prototype-test-report-detail', // 项目空间：样机管理 - 样机试装报告详情
  ProjectInspect = 'project-inspect', // 项目空间：质检
  ProjectInspectMaterial = 'project-inspect-material', // 项目空间：质检单 - 来料
  ProjectInspectProcedure = 'project-inspect-procedure', // 项目空间：质检单 - 工序 / IPQC
  ProjectInspectMachine = 'project-inspect-machine', // 项目空间：质检单 - 机台 / OQC
  ProjectInspectPackage = 'project-inspect-package', // 项目空间：质检单 - 包装 / FQC
  ProjectInspectPackageAuto = 'project-inspect-package-auto', // 项目空间：质检单 - 包装自动检验
  ProjectInspectOutput = 'project-inspect-output', // 项目空间：质检单 - 出货 / OQC
  ProjectInspectionChecklist = 'project-inspect-checklist', // 项目空间：质检单 - 巡检检验单 / IPQC
  ProjectInspectStandard = 'project-inspect-standard', // 项目空间：质检标准
  ProjectInspectStandardMaterial = 'project-inspect-standard-material', // 项目空间：质检标准 -物料
  ProjectInspectStandardMachine = 'project-inspect-standard-machine', // 项目空间：质检标准 -整机
  ProjectInspectStandardFinish = 'project-inspect-standard-finish', // 项目空间：质检标准 -成品
  ProjectInspectStandardProcess = 'project-inspect-standard-process', // 项目空间：质检标准 -巡检
  ProjectQCDrawing = 'project-qc-drawing', // 项目空间：质检标准 -QC工程图
  ProjectIssue = 'project-issue', // 项目空间：问题
  ProjectIssueList = 'project-issue-list', // 项目空间：问题列表
  ProjectIssueDetail = 'project-issue-detail', // 项目空间：问题详情
  ProjectIssueProductionMaterial = 'project-issue-production-material', // 项目空间：问题 - 来料问题
  ProjectIssueProductionProcess = 'project-issue-production-process', // 项目空间：问题 - 生产制程
  ProjectIssueTrialProduction = 'project-issue-trial-production', // 项目空间：问题 - 试产问题
  ProjectIssueRisk = 'project-issue-risk', // 项目空间：问题 - 风险
  ProjectSetting = 'project-setting', // 项目空间：项目设置
  ProjectSettingVersion = 'project-setting-version', // 项目空间：项目设置 - 版本管理
  ProjectSettingComponents = 'project-setting-components', // 项目空间：项目设置 - 模块管理
  ProjectSettingProduct = 'project-setting-product', // 项目空间：项目设置 - 生产设置
  ProjectSettingTR = 'project-setting-tr', // 项目空间：项目设置 - tr评审设置
  ProjectSettingProductProcessConfiguration = 'project-setting-product-process-configuration', // 项目空间：项目设置 - 生产设置 - 工序模块配置
  ProjectSettingSku = 'project-setting-sku', // 项目空间：项目设置-sku
  ProjectSettingBom = 'project-setting-bom', // 项目空间：项目设置-bom（关键物料配置）
  ProjectSettingSystem = 'project-setting-system', // 项目空间：项目成员配置
  ProjectSettingProcedure = 'project-setting-procedure', // 项目空间：项目设置-工序
  ProjectRR = 'project-rr', // 项目空间：生产-返工维修
  ProjectRepairList = 'project-repair-list', // 项目空间：生产-维修单
  ProjectReworkList = 'project-rework-list', // 项目空间：生产-维修单
  ProjectDev = 'project-dev', // 项目空间：研发
  ProjectDemandManage = 'project-dev-demand-management', // 项目空间：研发 - 需求管理
  ProductAndUIDemandListDetail = 'product-and-ui-demand-list-detail', // 项目空间：研发 - 需求管理 - 产品需求列表 - 详情
  ProductDemandAI = 'product-demand-viewer-ai', // 项目空间：研发 - 需求管理 - 产品需求文档 AI 空间
  // UIDemandListDetail = 'ui-demand-list-detail', // 项目空间：研发 - 需求管理 - UI需求列表 - 详情
  ProjectTestProgramme = 'project-dev-test-programme', // 项目空间：研发 - 测试方案
  ProjectTestManage = 'project-dev-test-management', // 项目空间：研发 - 测试管理
  ProjectSubmitTest = 'project-submit-test', // 项目空间：研发 - 项目提测
  ProjectTestPlan = 'project-test-plan', // 项目空间：研发 - 测试计划
  ProjectTestPlanDetail = 'test-plan-detail', // 项目空间：研发 - 测试计划 - 查看详情
  ProjectTestPlanReport = 'test-plan-report', // 项目空间：研发 - 测试计划 - 测试计划报告
  ProjectTestReport = 'project-test-report', // 项目空间：研发 - 测试报告
  ProjectTestReportDetail = 'test-report-detail', // 项目空间：研发 - 测试报告 - 查看测试报告
  ProjectTestRecordDetail = 'test-record-detail', // 项目空间：研发 - 提测记录 - 查看详情
  ProjectAutoTest = 'project-dev-auto-test', // 项目空间：研发 - 自动化测试
  ProjectORTTest = 'project-ort-test', // 项目空间：研发 - ORT测试
  ProjectORTTestReport = 'project-ort-test-report', // 项目空间：研发 - ORT测试 - 详情

  Production = 'production', // 生产质量管理
  ProductionDashboard = 'production-dashboard', // 生产质量管理：生产质量看板
  ProductionDashboardMaterial = 'production-dashboard-material', // 生产质量管理：生产质量看板 - 来料
  ProductionDashboardSupplier = 'production-dashboard-supplier', // 生产质量管理：生产质量看板 - 供应商
  ProductionDashboardProduce = 'production-dashboard-produce', // 生产质量管理：生产质量看板 - 生产制程
  ProductionMaterial = 'production-material', // 物料管理
  ProductionMaterialBug = 'production-material-bug', // 来料问题库
  ProductionMaterialSamples = 'production-material-samples', // 物料-样品清单
  ProductionMaterialInspectOrderList = 'production-material-inspect-order-list', // 来料检验单列表
  ProductionMaterialInspectOrderDetail = 'production-material-inspect-order-detail', // 来料检验单详情操作页
  ProductionMaterialWmsReceiveBill = 'production-material-wms-receive-bill', // WMS收料单
  ProductionMaterialReceiveBill = 'production-material-receive-bill', // 来料收料单
  ProductionMaterialInspectScheme = 'production-material-inspect-scheme', // 来料检验方案 - 涵盖检验规范（通用料、专用料），抽样方案，关系维护
  ProductionMaterialInspectSchemeViewer = 'production-material-inspect-scheme-viewer-ai', // 来料检验方案 - AI 空间
  ProductionORTTest = 'production-ort-test', // 项目空间：研发 - ORT测试
  ProductionORTTestReport = 'production-ort-test-report', // 项目空间：研发 - ORT测试 - 详情
  ProductionSupplier = 'production-supplier', // 供应商管理
  ProductionSupplierCheck = 'production-supplier-check', // 供应商管理：供应商审核（审厂）
  ProductionSupplierAudit = 'production-supplier-audit', // 供应商管理：供应商审核（新）
  ProductionSupplierCheckDetail = 'production-supplier-check-detail', // 供应商管理：供应商审核（审厂）
  ProductionSupplierTrack = 'production-supplier-track', // 供应商管理：供应商跟踪
  ProductionSupplierEvaluate = 'production-supplier-evaluate', // 供应商管理：供应商评价
  ProductionShipments = 'production-shipments', // 出货管理
  ProductionShipmentsWmsInspectOrder = 'production-shipments-wms-inspect-order', // 出货管理：WMS出货检验
  ProductionShipmentsWmsInspectDetail = 'production-shipments-wms-inspect-detail', // 出货管理：WMS出货单明细
  ProductionShipmentsInspectOrder = 'production-shipments-inspect', // 出货管理：K3出货检验
  ProductionShipmentsInspectStandard = 'production-shipments-inspect-standard', // 出货管理：出货检验规范
  ProductionShipmentsReviewOrder = 'production-shipments-review-order', // 出货管理：出货评审单
  ProductionShipmentsInspectDetail = 'production-shipments-inspect-detail', // 出货管理：出货单明细
  ProduceIssue = 'production-produce-issue', // 制程问题

  ProductionSetting = 'production-setting', // 生产质量管理：生产设置
  ProductionSettingBadCategory = 'production-setting-bad-category', // 生产质量管理：生产设置 - 不良分类配置
  ProductionSettingMeasures = 'production-setting-measures', // 生产质量管理：生产设置 - 不良对策配置 - 不良对策
  ProductionSettingAttribution = 'production-setting-attribution', // 生产质量管理：生产设置 - 不良归属
  ProductionSettingIqcAssignLogic = 'production-setting-iqc-assign-logic', // 生产质量管理：生产设置 - IQC分配逻辑
  ProductionSupplierStencilConfig = 'production-supplier-stencil-config', // 生产质量管理：供应商 - 供应商模版配置
  ProductionSettingSupplier = 'production-setting-supplier', // 生产质量管理：设置 - 供应商管理
  ProductionSettingFocusProjects = 'production-setting-focus-projects', // 生产质量管理：设置 - 关注项目
  ProductionSettingMaterialNgTarget = 'production-setting-material-ng-target', // 生产质量管理：设置 - 不良率目标

  AfterSale = 'after-sale', // 售后质量管理
  AfterSaleDashboard = 'after-sale-dashboard', // 售后质量管理：售后质量看板
  FEEDBACK_MANAGEMENT = 'feedback-management', // 反馈管理
  AFTER_SALES_DATA = 'after-sales-data', // 售后数据
  AFTER_SALES_ANALYSIS = 'after-sales-analysis', // 售后分析
  PUBLIC_OPINION_ANALYSIS = 'sentiment-analysis', // 舆情分析

  AfterSaleQuality = 'after-sale-quality', // 售后质量（全新并行模块）
  AfterSaleQualitySourceData = 'after-sale-quality-source-data', // 售后质量：客诉源数据
  AfterSaleQualityDashboard = 'after-sale-quality-dashboard', // 售后质量：指标看板（二期）
  AfterSaleQualityBaseNumber = 'after-sale-quality-base-number', // 售后质量：激活数录入（二期）
  AfterSaleQualityIssue = 'after-sale-quality-issue', // 售后质量：问题管理（三期）
  AfterSaleQualityIssueDetail = 'after-sale-quality-issue-detail', // 售后质量：问题详情页（独立路由）

  Development = 'development', // 研发质量管理
  DevelopmentDashboard = 'development-dashboard', // 研发质量管理：研发质量看板-质量详情
  DevelopmentDashboardVersion = 'development-dashboard-version', // 研发质量管理：研发质量看板 - 版本对比
  DevelopmentDashboardReport = 'development-dashboard-report', // 研发质量管理：研发质量看板 - 质量报告

  DevelopmentDemandList = 'dev-demand-list', // 研发质量管理：研发质量看板 - 需求列表
  DevelopmentTestRecordList = 'dev-test-record-list', // 研发质量管理：研发质量看板 - 测试记录列表
  DevelopmentTestReportList = 'dev-test-report-list', // 研发质量管理：研发质量看板 - 测试报告列表

  DevelopmentClientPerformanceReport = 'development-client-performance-report', // 研发质量管理：研发质量看板 - 客户端性能报告
  DevelopmentClientPerformanceCaseDetail = 'development-client-performance-case-detail', // 研发质量管理：研发质量看板 - 客户端性能用例详情
  DevelopmentUIAutomationReport = 'development-ui-automation-report', // 研发质量管理：研发质量看板 - UI自动化报告
  MyDashboard = 'my-dashboard', // 我的看板
  CustomerDashboard = 'customer-dashboard', // 自定义看板
  DashboardManage = 'dashboard-manage', // 看板管理
}
